export function detectTextInfo(text = "") {
  if (!text.trim()) {
    return {
      direction: "ltr",
      language: "unknown",
      languageName: "Unknown",
    };
  }

  const rtlRegex =
    /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u0780-\u07BF\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

  const direction = rtlRegex.test(text) ? "rtl" : "ltr";

  let language = "unknown";
  let languageName = "Unknown";

  // Dhivehi (Thaana)
  if (/[\u0780-\u07BF]/.test(text)) {
    language = "dv";
    languageName = "Dhivehi";
  }
  // Arabic
  else if (/[\u0600-\u06FF]/.test(text)) {
    language = "ar";
    languageName = "Arabic";
  }
  // Hebrew
  else if (/[\u0590-\u05FF]/.test(text)) {
    language = "he";
    languageName = "Hebrew";
  }
  // Russian
  else if (/[\u0400-\u04FF]/.test(text)) {
    language = "ru";
    languageName = "Russian";
  }
  // Chinese
  else if (/[\u4E00-\u9FFF]/.test(text)) {
    language = "zh";
    languageName = "Chinese";
  }
  // Japanese
  else if (/[\u3040-\u309F\u30A0-\u30FF]/.test(text)) {
    language = "ja";
    languageName = "Japanese";
  }
  // Korean
  else if (/[\uAC00-\uD7AF]/.test(text)) {
    language = "ko";
    languageName = "Korean";
  }
  // Hindi
  else if (/[\u0900-\u097F]/.test(text)) {
    language = "hi";
    languageName = "Hindi";
  }
  // English / Latin script
  else if (/[a-zA-Z]/.test(text)) {
    language = "en";
    languageName = "English";
  }

  return {
    direction,
    language,
    languageName,
  };
}

export function getSpeechLang(text: string) {

  const { language } = detectTextInfo(text);

  const map: Record<string, string> = {

    en: "en-US",

    ar: "ar-SA",

    dv: "dv-MV",

    he: "he-IL",

    ru: "ru-RU",

    zh: "zh-CN",

    ja: "ja-JP",

    ko: "ko-KR",

    hi: "hi-IN",

  };

  return map[language] || "en-US";

}